<template>
  <div>
    <div class="content-wizard">
      <div class="row">
        <div class="col-lg-12">
          <h3 class="font-bold">Choisir l'adresse de référence pour le rendez-vous :</h3>
          <div class="m-t-md">
            <div class="i-checks">
              <div class="i-checks">
                <label for="owner_address"
                       class="label-address">
                  <input id="owner_address"
                         type="radio"
                         :value="ownerAddressInputValue"
                         name="address_choice"
                         v-validate="'required'"
                         v-model="type">
                  <span>Adresse du {{ isSellerOwner ? 'vendeur et ' : '' }}propriétaire actuel : {{ ownerAddress }}</span>
                </label>
              </div>
            </div>
          </div>
          <div v-if="!isSellerOwner"
               class="m-t-md">
            <div class="i-checks">
              <div class="i-checks">
                <label for="seller_address"
                       class="label-address">
                  <input id="seller_address"
                         type="radio"
                         :value="2"
                         name="address_choice"
                         v-model="type">
                  <span>Adresse du vendeur : {{ sellerAddress }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="m-t-md">
            <div class="i-checks">
              <div class="i-checks">
                <label for="other_address"
                       class="label-address">
                  <input id="other_address"
                         type="radio"
                         :value="0"
                         name="address_choice"
                         v-model="type">
                  <span>Utiliser une autre adresse</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group m-t"
               :class="{'has-error': false}">
            <gmap-autocomplete ref="gmapAddress"
                               :componentRestrictions="{'country': ['fr']}"
                               placeholder="Adresse"
                               class="form-control"
                               @change="resetAddress"
                               @place_changed="onClickPlace"
                               :disabled="!isAddressOther"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button type="button"
                class="btn btn-w-m btn-primary pull-right"
                :disabled="type === 0 && !address.address"
                @click="onSubmit">Choisir cette adresse</button>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { formatAddress, addressToString } from '../../../helpers/utils'
  import { isAddressIncompleteMixin } from '@/mixins/isAddressIncompleteMixin'

  const CURRENT_OWNER = 1
  const SELLER = 2
  const OWNER_AND_SELLER = 3

  export default {
    props: {
      seller: {
        type: Object,
        required: true
      },

      owner: {
        type: Object,
        required: true
      },

      command: {
        type: Object,
        required: true
      },

      initialSaleRdv: {
        type: Object,
        required: true
      }
    },

    mixins: [isAddressIncompleteMixin],

    data: () => ({
      referenceAddress: null,
      type: null,
      address: {},
      coordinate: {
        latitude: null,
        longitude: null,
      }
    }),

    computed: {
      ownerAddressInputValue () {
        if(this.isSellerOwner){
          return OWNER_AND_SELLER
        } else {
          return CURRENT_OWNER 
        }       
      },

      sellerAddress () {
        return `${this.seller.firstname} ${this.seller.lastname}, ${addressToString(this.seller.address)}`
      },

      ownerAddress () {
        return `${this.owner.firstName} ${this.owner.lastName}, ${addressToString(this.owner.address)}`
      },

      commandId () {
        return this.$route.params.id
      },

      isAddressOther () {
        return parseInt(this.type) === 0
      },

      isSellerOwner () {
        return this.sellerAddress === this.ownerAddress
      },

      referenceAddressQuery () {
        return gql`
          query {
            referenceAddress(orderId: "${this.commandId}") {
              addressType
              address
              zipCode
              city
            }
          }
        `
      },

      saleRdvQuery () {
        return gql`
        query {
          saleRdvAddress(orderId: "${this.commandId}") {
            type
            address {
              address
              city
              zipCode
            }
          }
        }`
      },

      saleRdvMutation () {
        if (this.initialSaleRdv.id) {
          return gql`
          mutation {
            updateSaleRdv(saleRdvId: "${this.initialSaleRdv.id}",
              addressType: ${this.type},
              address: {
              address: "${this.address.address || ''}",
              zipCode: "${this.address.zipCode || ''}",
              city: "${this.address.city || ''}"
              })
            {
            result
            status
            id
            }
          }`
        }
        return gql`
          mutation {
            addSaleRdv(orderId:"${this.commandId}",
            addressType: ${this.type},
            address: {
              address: "${this.address.address || ''}",
              zipCode: "${this.address.zipCode || ''}",
              city: "${this.address.city || ''}"
            })
            {
              result
              status
              id
            }
          }`

        return `${this.seller.firstname} ${this.seller.lastname}, ${this.seller.address.address}, ${this.seller.address.zipcode} ${this.seller.address.city}`
      },
    },

    watch: {
      address () {
        if (this.address && this.type) {
          if (this.type === "0") {
            setTimeout(() => {
              if (!this.isAddressIncomplete(this.address)) {
                this.$refs.gmapAddress.$el.value = addressToString(this.address)
              }
            }, 10)
          }
        }
      }
    },

    mounted () {
      if (this.initialSaleRdv.id) {
        this.$apollo.query({
          query: this.referenceAddressQuery,
          fetchPolicy: 'no-cache'
        }).then(response => {
          this.address = {
            address: response.data.referenceAddress.address,
            zipCode: response.data.referenceAddress.zipCode,
            city: response.data.referenceAddress.city
          }
          this.type = response.data.referenceAddress.addressType
        })
      }
    },

    methods: {
      resetAddressInput () {
        this.$refs.gmapAddress.$el.value = ""
      },

      resetAddress () {
        this.address = {};
      },

      onClickPlace (place) {
        this.address = formatAddress(place)
        this.coordinate.latitude = place.geometry.location.lat();
        this.coordinate.longitude = place.geometry.location.lng();
      },

      onSubmit () {
        if (parseInt(this.type) === CURRENT_OWNER || parseInt(this.type) === OWNER_AND_SELLER) {
          this.address = this.owner.address
        } else if (parseInt(this.type) === SELLER) {
          this.address = this.seller.address
        }

        if (this.isAddressIncomplete(this.address)) {
          this.showBanner('danger', 'Veuillez sélectionne une adresse ou en saisir une.')
        } else {
          this.$apollo.mutate({
            mutation: this.saleRdvMutation
          }).then(response => {
            let newInitialSaleRdvValue = this.initialSaleRdv
            newInitialSaleRdvValue.address = this.address
            if (this.initialSaleRdv.id) {
              newInitialSaleRdvValue.id = response.data.updateSaleRdv.id
            } else {
              newInitialSaleRdvValue.id = response.data.addSaleRdv.id
            }
            this.$emit('update-initialSaleRdv-value', newInitialSaleRdvValue)

            this.showBanner('success', 'Les informations ont bien été modifiées.')
            this.$parent.toggleBlock(2)
          }, () => {
            this.showBanner('danger', 'Les informations n\'ont pas pu être modifiées.')
          })
        }
      }
    },

    apollo: {
      referenceAddress: {
        query () {
          return this.referenceAddressQuery
        }
      }
    }
  }
</script>
